<div class="component-wrapper">
    <form class="form" (ngSubmit)="register()" [formGroup]="registrationForm">
        <div class="salutation">
            <kendo-formfield class="anrede">
                <kendo-label class="form-label" [for]="anrede" text="{{'contact.salutation' | translate}}"></kendo-label>
                <kendo-combobox formControlName="anredeId" [valuePrimitive]="true" #anrede [allowCustom]="false"
                    [data]="anredeItems" [valueField]="'anredeId'" [textField]="'name'" kendoDropDownFilter (valueChange)="loadAnreden()">
                </kendo-combobox>
            </kendo-formfield>
            <kendo-formfield class="titel">
                <kendo-label class="form-label" class="form-label" [for]="akadtitel" text="{{'contact.title' | translate}}"></kendo-label>
                <kendo-combobox formControlName="titelId" [valuePrimitive]="true" #akadtitel [allowCustom]="false"
                    [data]="titelItems" [valueField]="'titelId'" [textField]="'name'" kendoDropDownFilter>
                </kendo-combobox>
            </kendo-formfield>
        </div>
        <div class="name">
            <kendo-formfield class="vorname">
                <kendo-label class="form-label" [for]="vorname" text="{{'contact.firstName' | translate }} *"></kendo-label>
                <kendo-textbox #vorname placeholder="{{'contact.firstName' | translate }}" [attr.aria-label]="'contact.firstName' | translate" formControlName="vorname" showSuccessIcon="initial"
                    showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of vornameErrorMessages" role="alert">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield class="nachname">
                <kendo-label class="form-label" [for]="nachname" text="{{'contact.lastname' | translate }} *"></kendo-label>
                <kendo-textbox #nachname placeholder="{{'contact.lastname' | translate }}" [attr.aria-label]="'contact.lastname' | translate" formControlName="nachname" showSuccessIcon="initial"
                    showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of nachnameErrorMessages" role="alert">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <kendo-formfield class="email">
            <kendo-label class="form-label" [for]="benutzername" text="{{'auth.email' | translate}} *"></kendo-label>
            <kendo-textbox #benutzername [readonly]="true" [disabled]="true" placeholder="{{'auth.email' | translate}}"
                formControlName="email" [attr.aria-label]="'auth.email' | translate"></kendo-textbox>
        </kendo-formfield>
        <div class="passwordContainer" *ngIf="isPasswordFieldVisible">
            <kendo-formfield class="password">
                <kendo-label class="form-label" [for]="password" text="{{'register.password' | translate}} *"></kendo-label>
                <kendo-textbox #password placeholder="{{'register.password' | translate}}" [attr.aria-label]="'register.password' | translate" formControlName="passwort" showSuccessIcon="initial"
                    showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of passwortErrorMessages" role="alert">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield class="passwordW">
                <kendo-label class="form-label" [for]="passwordW" text="{{'register.repeatPassword' | translate}} *"></kendo-label>
                <kendo-textbox #passwordW placeholder="{{'register.repeatPassword' | translate}}" [attr.aria-label]="'register.repeatPassword' | translate" formControlName="passwortWiederholen"
                    showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of passwortWiederholenErrorMessages" role="alert">{{errorMessage}}
                </kendo-formerror>
            </kendo-formfield>
        </div>
        <div class="submit-wrapper">
            <button kendoButton class="registrieren" type="submit"
                [disabled]="isPasswordFieldVisible && (registrationForm.invalid || isLoading)" [innerHTML]="'register.register' |translate">
            </button>
                
        </div>
    </form>
</div>